import React from "react";
import { Switch, Route, Link, Redirect, withRouter, matchPath } from "react-router-dom";

import { TransitionGroup, CSSTransition } from "react-transition-group";
import { gsap } from "gsap";
import { TweenMax as TM } from "gsap/all";

import { Pages, AllPages } from "./pages/Pages";
// import Error404 from "./404";
import Progress from "./Progress";
import Arrows from "./Arrows";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import "./App.scss";
import "./sass/media/responsive.scss";

import { hasClass, removeClass, addClass } from "./util/util";

import Scrollbar from "react-smooth-scrollbar";
import SmoothScrollbar from "smooth-scrollbar";
import OverscrollPlugin from "smooth-scrollbar/plugins/overscroll";
import HorizontalScrollPlugin from "./util/HorizontalScrollPlugin";
import Popout from "./Popout";
import BackButton from "./BackButton";

SmoothScrollbar.use(HorizontalScrollPlugin, OverscrollPlugin);

const logoOffset = 50;

class App extends React.Component {
  constructor(props) {
    super(props);

    this.progress = 0;
    this.progressOld = 0;
    this.yProgress = 0;
    this.bgColor = "default";
    this.loadedImages = "";
    this.scrollbar = {};

    this.state = {
      scrollbar: "",
      progressWidth: 0,
      prevClass: "hide",
      nextClass: "show",
      hoverState: "hover-default",
      popout: false,
      loadedImages: [],
      popImgs: [],
      photoIndex: 0,
      photoOpen: false,
      prevPath: this.props.location
    };

    this.setHoverState = this.setHoverState.bind(this);
    this.setImageObjects = this.setImageObjects.bind(this);
    this.progressBarHandler = this.progressBarHandler.bind(this);
    this.handlePopoutImages = this.handlePopoutImages.bind(this);
  }

  componentDidMount() {
    const { scrollbar } = this.$container;
    const _ = this;

    this.scrollbar = scrollbar;

    _.setState({
      scrollbar: scrollbar,
      prevClass: scrollbar.offset.x < 300 ? "hide" : "show"
    });

    this.bindEvents(scrollbar);

  }

  componentDidUpdate(prevProps) {
    const { scrollbar } = this.$container;
    const _ = this;

    this.scrollbar = scrollbar;

    scrollbar.updatePluginOptions("horizontalScroll", {
      scrollXAxis: this.props.location.pathname === "/"
    });

    if (
      prevProps.location.pathname !== this.props.location.pathname &&
      this.props.location.pathname === "/"
    ) {
      removeClass(document.body, "scrolled-passed");
      setTimeout(function() {
        if (!isNaN(_.progressOld))
          scrollbar.scrollTo(_.progressOld * scrollbar.limit.x, 0, 1000);
      }, 300);
    }

    if (prevProps.location !== this.props.location) {
      this.setState({ prevPath: prevProps.location })
    }
  }


  setHoverState(e) {
    this.bgColor =
      e.currentTarget !== undefined
        ? e.currentTarget.getAttribute("data-color")
        : e;

    this.setState({
      hoverState: `hover-${this.bgColor}`
    });
  }

  setImageObjects(imgs) {
    this.loadedImages = [];
    imgs = Array.from(imgs);

    if (imgs.length) {
      for (var i = 0; i < imgs.length; i++) {
        this.loadedImages.push({ imageListener: "", img: imgs[i] });
        // gsap.set(imgs[i], {opacity: 0, scale: 0.2});
        gsap.set(imgs[i], { opacity: 0, y: 50, force3D: false });
      }

      this.setState({
        loadedImages: this.loadedImages
      });
    }
  }

  bindEvents(scrollbar) {
    scrollbar.addListener(s => {
      this.onScroll(s);

      this.limits = s;

      if (this.state.loadedImages.length > 0) {
        this.state.loadedImages.forEach((el, i) => {
          if (scrollbar.isVisible(this.state.loadedImages[i].img)) {
            // gsap.to(this.state.loadedImages[i].img, {duration: 0.5, delay: 0.2, opacity: 1, scale: 1, force3D: false});
            gsap.to(this.state.loadedImages[i].img, {
              duration: 0.5,
              delay: 0.2,
              opacity: 1,
              y: 0,
              force3D: false
            });
          }
        });
      }
    });
  }

  onScroll({ limit, offset }) {
    this.setState({
      progressWidth: (offset.x / limit.x) * 100,
      prevClass: offset.x < limit.x * 0.1 ? "hide" : "show",
      nextClass: offset.x > limit.x - limit.x * 0.1 ? "hide" : "show"
    });

    if (!isNaN(this.progress)) this.progressOld = this.progress;

    this.progress = offset.x / limit.x;
    this.yProgress = offset.y / limit.y;

    if (
      offset.y > parseFloat(window.innerHeight + 150) &&
      !hasClass(document.body, "scrolled-passed")
    ) {
      addClass(document.body, "scrolled-passed");
    } else if (
      offset.y <= parseFloat(window.innerHeight + 150) &&
      hasClass(document.body, "scrolled-passed")
    ) {
      removeClass(document.body, "scrolled-passed");
    }

    this.parallaxAnimations({ limit, offset });
  }

  parallaxAnimations = ({ limit, offset }) => {
    TM.to(document.querySelector(".logo-100"), 0.3, {
      x: -this.progress * logoOffset,
      y: offset.y * -0.2,
      force3D: false
    });
    TM.to(document.querySelector("header"), 0.3, {
      y: offset.y * -0.5,
      force3D: false
    });
    TM.to(document.querySelectorAll(".anim-up"), 0.3, {
      y: offset.y * -0.3,
      force3D: false
    });
    TM.to(document.querySelectorAll(".anim-down"), 0.3, {
      y: offset.y * 0.3,
      force3D: false
    });
  };

  progressBarHandler = e => {
    let bounds = document
      .getElementsByClassName("carousel-progress")[0]
      .getBoundingClientRect();
    let posX = ((e.clientX - bounds.left) * 100) / 210;
    this.scrollbar.scrollTo(this.scrollbar.limit.x * (posX / 100), 0, 1000);
  };

  handleTogglePopout = () => {
    this.setState({
      popout: !this.state.popout
    });
  };

  displayPopout = () => {
    if (this.state.popout === true) {
      return <Popout togglePopout={this.handleTogglePopout} />;
    }
  };

  gatherPopoutImages = arr => {
    this.setState({
      popImgs: arr
    });
  };

  handlePopoutImages = e => {
    for (var i = 0; i < this.state.popImgs.length; i++) {
      var imgSrc =
        e.target.querySelector("img") != null
          ? e.target.querySelector("img").getAttribute("src")
          : e.target.getAttribute("src");

      if (imgSrc.indexOf(this.state.popImgs[i]) > -1) {
        this.setState({
          photoIndex: i,
          photoOpen: true
        });
      }
    }
  };

  render() {
    return (
      <div
        className={`background ${this.state.hoverState}`}
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/images/map.jpg')`
        }}
      >
        <div className="logo-100">
          <img
            className="logo-default"
            src={`${process.env.PUBLIC_URL}/images/100-dark.png`}
            alt=""
          />
          <img
            className="logo-green"
            src={`${process.env.PUBLIC_URL}/images/100-green.png`}
            alt=""
          />
        </div>
        <header id="header">
          <div className="logo-wrapper">
            <Link to="/" className="inner">
              <img
                src={`${process.env.PUBLIC_URL}/images/logo.png`}
                className="logo"
                alt=""
              />
              <img
                src={`${process.env.PUBLIC_URL}/images/logo-text-1.png`}
                alt=""
              />
              <img
                src={`${process.env.PUBLIC_URL}/images/logo-text-2.png`}
                alt=""
              />
            </Link>
          </div>
        </header>
        <Scrollbar
          id="Scrollbar"
          ref={c => (this.$container = c)}
          continuousScrolling={false}
          plugins={{
            overscroll: { effect: "bounce", damping: 0.1 }
          }}
        >
          <TransitionGroup>
            <CSSTransition
              key={this.props.location.key}
              timeout={{ enter: 300, exit: 300 }}
              classNames={"fade"}
            >
              <Switch location={this.props.location}>
                {AllPages.map(({ path, Component }) => (
                  <Route key={path} exact path={path}>
                    <Component
                      bgHoverState={this.setHoverState}
                      togglePopout={this.handleTogglePopout}
                      popoutToggled={this.props.popout}
                      imageObjects={this.setImageObjects}
                      popoutImages={this.handlePopoutImages}
                      gatherImages={this.gatherPopoutImages}
                    />
                  </Route>
                ))}
                <Redirect to="/" />
                {/* <Route>
                  <Error404 errorPath={this.state.prevPath} />
                </Route> */}
              </Switch>
            </CSSTransition>
          </TransitionGroup>
        </Scrollbar>
        <Progress
          progressWidth={this.progress * 100 + "%"}
          clickHandler={this.progressBarHandler}
        />
        <Arrows
          scrollbar={this.state.scrollbar}
          prevClass={this.state.prevClass}
          nextClass={this.state.nextClass}
        />
        <BackButton bgHoverState={this.setHoverState} />
        {this.displayPopout()}
        {this.state.photoOpen && (
          <Lightbox
            mainSrc={this.state.popImgs[this.state.photoIndex]}
            nextSrc={
              this.state.popImgs[
                (this.state.photoIndex + 1) % this.state.popImgs.length
              ]
            }
            prevSrc={
              this.state.popImgs[
                (this.state.photoIndex + this.state.popImgs.length - 1) %
                  this.state.popImgs.length
              ]
            }
            onCloseRequest={() => this.setState({ photoOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (this.state.photoIndex + this.state.popImgs.length - 1) %
                  this.state.popImgs.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex:
                  (this.state.photoIndex + 1) % this.state.popImgs.length
              })
            }
          />
        )}
      </div>
    );
  }
}

export default withRouter(App);
